import {useSelector} from 'react-redux';

export default function useHasFeature(feature) {
    const features = useSelector(state => (state.app?.org?.features || {}));
    return features[feature] === true;
}
